<template>
  <div class="position-relative">
    <input
      :id="id"
      :value="modelValue"
      :type="showPassword ? 'text' : 'password'"
      :placeholder="placeholder"
      :aria-label="ariaLabel"
      :disabled="disabled"
      class="form-control form-control-lg"
      @input="$emit('update:modelValue', $event.target.value)"
      @blur="$emit('blur')"
      @focus="$emit('focus')"
    />
    <button
      type="button"
      class="btn btn-link position-absolute end-0 top-50 translate-middle-y me-2 p-1"
      style="z-index: 10; border: none; background: none;"
      :tabindex="disabled ? -1 : 0"
      @click="togglePasswordVisibility"
    >
      <i 
        :class="showPassword ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'" 
        class="text-muted"
        style="font-size: 1rem;"
      ></i>
    </button>
  </div>
</template>

<script setup>
import { ref } from 'vue';

defineProps({
  id: {
    type: String,
    default: ''
  },
  modelValue: {
    type: String,
    default: ''
  },
  placeholder: {
    type: String,
    default: ''
  },
  ariaLabel: {
    type: String,
    default: ''
  },
  disabled: {
    type: Boolean,
    default: false
  }
});

defineEmits(['update:modelValue', 'blur', 'focus']);

const showPassword = ref(false);

const togglePasswordVisibility = () => {
  showPassword.value = !showPassword.value;
};
</script>

<style scoped>
.form-control {
  padding-right: 3rem !important;
}

.btn-link {
  text-decoration: none;
  color: inherit;
}

.btn-link:hover {
  color: inherit;
  text-decoration: none;
}

.btn-link:focus {
  box-shadow: none;
}
</style>